<template>
    <div class="page-info page-content" v-loading="body_loading">
        <div class="main-body">
            <el-row class="hd">
                <el-col :span="24">
                    <h3 style="float: none;">个人信息</h3>
                    <div class="flex-block breadcrumb-box">
                        <div class="position-text">位置：</div>
                        <el-breadcrumb separator-class="el-icon-arrow-right">
                            <el-breadcrumb-item>个人中心</el-breadcrumb-item>
                            <el-breadcrumb-item>个人信息</el-breadcrumb-item>
                        </el-breadcrumb>
                    </div>
                </el-col>
            </el-row>
            <div class="bd">
                <div class="content-body">
                    <div class="msg-item"><span>用户手机号码：</span>{{msg.mobilePhone}}</div>
                    <div class="msg-item"><span>用户名：</span>{{msg.userName}}</div>
                   
                   <!-- <div class="msg-item"><span>头像：</span>
                        <img class="cursor" :src="baseUrl + msg.head_portrait" height="50" @click="dlg_preview.img_url = baseUrl + msg.head_portrait;dlg_preview.visible = true;" title="点击查看" />
                        <el-upload
                                :action="upload.params.action"
                                :headers="upload.params.headers"
                                :data="upload.params.data"
                                accept="image/png,image/jpeg,image/jpg"
                                class="info-upload"
                                :file-list="upload.img_list"
                                :show-file-list="false"
                                name="file"
                                :on-preview="(file) => {dlg_preview.img_url = file.url;dlg_preview.visible = true;}"
                                :on-success="uploadSuccessImg">
                            <el-button size="small" type="text" class="change-btn">修改头像</el-button>
                        </el-upload>
                    </div> -->
                  <!--  <div class="msg-item"><span>当前角色：</span>
                        <i v-for="(item, index) in role_info" :key="index">{{item.name}} </i>
                    </div> -->
                 <!--   <div class="msg-item"><span>最后登录时间：</span>{{msg.last_login_time}}</div>
                    <div class="msg-item"><span>最后登录有效时间：</span>{{login_effective_time}}</div> -->
                </div>
                <!--<div class="content-body">
                </div>-->
                <!--<div class="content-body">
                    <div class="msg-item"><span>手机号码：</span>{{form_mobile.o_mobile }} <el-button v-show="!showMobile" class="change-btn" type="text"  size="small" @click='showMobile=true'>修改手机号</el-button></div>
                    <el-form v-show="showMobile" :inline="true" :model="form_mobile" class="demo-form-inline msg-form" label-width="140px">
                        <el-form-item prop="o_vercode" label="验证手机：">
                            <el-input v-model="form_mobile.o_vercode" class="code_input" clearable placeholder='输入验证码'></el-input>
                            <el-button type="text" class="get_code" @click="getOldCode()" :disabled="o_count_down.time == 60 ? false : true">
                                <span v-if="o_count_down.time == 60">{{o_codeText}}</span>
                                <span v-else>已发送({{o_count_down.time}}s)</span>
                            </el-button>
                        </el-form-item>
                        <el-form-item prop="mobile" label="新手机号：">
                            <el-input v-model="form_mobile.mobile" placeholder="输入新手机号" clearable></el-input>
                        </el-form-item>
                        <el-form-item prop="vercode" label="验证新手机：">
                            <el-input v-model="form_mobile.vercode" class="code_input"  placeholder="输入验证码" clearable></el-input>
                            <el-button type="text" class="get_code" @click="getCode()" :disabled="count_down.time == 60 ? false : true">
                                <span v-if="count_down.time == 60">{{codeText}}</span>
                                <span v-else>已发送({{count_down.time}}s)</span>
                            </el-button>
                        </el-form-item>
                        <el-form-item label=" " class="msg-form-btn">
                            <el-button type="primary" class="btn-bg-p"  size="small" @click='saveMobile()'>保存</el-button>
                            <el-button type="primary" class="btn-bd-p"  size="small" @click='cancelMobile()'>取消</el-button>
                        </el-form-item>
                    </el-form>
                </div>-->
               <!-- <div class="content-body">
                    <div class="msg-item"><span>登录密码：</span>****** <el-button v-show="!showPsd" type="text" class="change-btn"  size="small" @click='showPsd=true'>修改密码</el-button></div>
                    <el-form v-show="showPsd" :inline="true" :model="form_psd" class="demo-form-inline msg-form" label-width="140px">
                       <el-form-item prop="old_password" label="输入原密码：">
                            <el-input v-model="form_psd.old_password" placeholder="输入原密码" clearable show-password></el-input>
                        </el-form-item>
                        <el-form-item prop="new_password" label="输入新密码：">
                            <el-input v-model="form_psd.new_password" placeholder="输入新密码" clearable show-password></el-input>
                        </el-form-item>
                        <el-form-item prop="r_password" label="确认密码：">
                            <el-input v-model="form_psd.r_password" placeholder="确认密码" clearable show-password></el-input>
                        </el-form-item>
                        <el-form-item class="msg-form-btn" label=" ">
                            <el-button type="primary" class="btn-bg-p"  size="small" @click='savePsd()'>保存</el-button>
                            <el-button type="primary" class="btn-bd-p"  size="small" @click='cancelPsd()'>取消</el-button>
                        </el-form-item>
                    </el-form>
                </div> -->
            </div>
        </div>
        <el-dialog :visible.sync="dlg_preview.visible" class="dialog-no-title text-center" width="420px">
            <img width="100%" :src="dlg_preview.img_url" style="max-width:100%;">
        </el-dialog>
    </div>
</template>
<script>
    import CryptoJS from 'crypto-js'
    import bus from '@/assets/js/defined.js'
    export default {
        name: 'info',
        data(){
            return {
                body_loading:false,
                o_codeText:'获取验证码',
                codeText:'获取验证码',
                count_down: {
                    time: 60,
                    fn: undefined,
                },
                o_count_down: {
                    time: 60,
                    fn: undefined,
                },
                upload:{
                    params:{
                        action: this.$client.API_URL+'/adminapi/upload/images',
                        data:{path:'admin'},
                        headers:{token:localStorage.getItem('token')}
                    },
                    img_list: [],
                },
                baseUrl:this.$client.IMG_URL,
                head_img:'',
                form_name:{
                    name:''
                },
                form_mobile:{
                    o_mobile:"",
                    mobile:"",
                    vercode:"",
                    o_vercode:""
                },
                form_psd:{
                    old_password:"",
                    new_password:"",
                    r_password:""
                },
                msg:{},
                login_effective_time: '',
                role_info:[],
                showName:false,
                showMobile:false,
                showPsd:false,
                dlg_preview:{
                    visible: false,
                    img_url: ''
                }
            }
        },
        created(){
            document.title = '个人信息';
            this.getInitData();
        },
        methods: {
            getInitData(){
                var _this = this;
                _this.body_loading = true;
                this.$client.get('/api/sys/user/getModelVoForCurrentUser', {}, function(res){
                    _this.msg = res;
                    _this.head_img = res.info.head_portrait;
                    _this.login_effective_time = res.login_effective_time;
                    _this.role_info = res.role_info;
                    _this.body_loading = false;
                    bus.$emit('headChange',_this.head_img);
                    localStorage.setItem('head_portrait',res.info.head_portrait);
                },function(res){
                    _this.body_loading = false;
                });
            },
            submitInfo(name,head_portrait){
                var _this = this;
                var params = {
                    name:name,
                    head_portrait:head_portrait
                };
                this.$client.post('/adminapi/admin/setinfo', params, function(res,message){
                    //console.log(message);
                    _this.$message(message);
                    _this.showName=false;
                    _this.getInitData();
                },function(res){
                    _this.body_loading = false;
                });
            },

            uploadSuccessImg(res, file, fileList){
                this.upload.img_list = fileList;
                this.msg.head_portrait = res.data.file_url;
                this.submitInfo(this.msg.name,this.msg.head_portrait);
            },
            oCountDown(){
                var _this = this;
                if(this.o_count_down.time == 0){
                    this.o_count_down.time = 60;
                    this.o_codeText = "重新获取";
                    return;
                }else{
                    this.o_count_down.time--;
                }
                this.o_count_down.fn = setTimeout(function(){
                    _this.oCountDown();
                },1000);
            },
            countDown(){
                var _this = this;
                if(this.count_down.time == 0){
                    this.count_down.time = 60;
                    this.codeText = "重新获取";
                    return;
                }else{
                    this.count_down.time--;
                }
                this.count_down.fn = setTimeout(function(){
                    _this.countDown();
                },1000);
            },
            getOldCode(){
                var _this = this;
                var params = {
                    account:_this.form_mobile.o_mobile,
                    utype:9,
                    account_type:"mobile"
                };
                _this.$client.post('/api/account/sendvercode', params, function(res,message){
                    _this.oCountDown();
                }, function(res){
                    //_this.getCaptcha();
                },true);
            },
            getCode(){
                var _this = this;
                if(_this.form_mobile.mobile == ''){
                    _this.$message("请输入新手机号码");
                    return;
                }
                var params = {
                    account:_this.form_mobile.mobile,
                    utype:5,
                    account_type:"mobile"
                };
                _this.$client.post('/api/account/sendvercode', params, function(res,message){
                    _this.countDown();
                }, function(res){
                    //_this.getCaptcha();
                },true);
            },
            saveName(){
                var _this = this;
                if(_this.form_name.name == ''){
                    _this.$message("请输入新名字");
                    return;
                }
                this.submitInfo(this.form_name.name,this.msg.head_portrait);
            },
            cancelName(){
                this.showName=false;
                this.form_name.name = '';
            },
            saveMobile(){
                var _this = this;
                if(_this.form_mobile.o_vercode == ''){
                    _this.$message("请输入原手机验证码");
                    return;
                }else if(_this.form_mobile.mobile == ''){
                    _this.$message("请输入新手机号码");
                    return;
                } else if(_this.form_mobile.vercode == ''){
                    _this.$message("请输入新手机验证码");
                    return;
                }
                var params = {
                    o_mobile:_this.form_mobile.o_mobile,
                    mobile:_this.form_mobile.mobile,
                    o_vercode:_this.form_mobile.o_vercode,
                    vercode:_this.form_mobile.vercode,
                };
                _this.$client.post('/api/user/changemobile', params, function(res,message){
                    _this.$message("换绑手机成功");
                    _this.getInitData();
                    _this.form_mobile.mobile = '';
                    _this.form_mobile.o_vercode = '';
                    _this.form_mobile.vercode = '';
                    _this.o_count_down.time = 60;
                    _this.o_count_down.fn = undefined;
                    _this.o_codeText = "获取验证码";
                    _this.count_down.time = 60;
                    _this.count_down.fn = undefined;
                    _this.codeText = "获取验证码";
                }, function(res){
                    //_this.getCaptcha();
                },true);
            },
            cancelMobile(){
                this.showMobile=false;
                this.form_mobile.mobile = '';
                this.form_mobile.o_vercode = '';
                this.form_mobile.vercode = '';
            },
            savePsd(){
                var _this = this;
                // if(_this.form_psd.old_password == ''){
                //     _this.$message("请输入原密码");
                //     return;
                // }else 
				if(_this.form_psd.new_password == ''){
                    _this.$message("请输入新密码");
                    return;
                }else if(_this.form_psd.new_password != _this.form_psd.r_password){
                    _this.$message("两次新密码输入不一致");
                    return;
                }
                var params = {
                    old_password:CryptoJS.MD5(_this.form_psd.old_password).toString(),
                    new_password:CryptoJS.MD5(_this.form_psd.new_password).toString()
                };
                _this.$client.post('/adminapi/admin/changepassword', params, function(res,message){
                    _this.$message("密码修改成功");
                    _this.form_psd.old_password = '';
                    _this.form_psd.new_password = '';
                    _this.form_psd.r_password = '';
                }, function(res){

                });
            },
            cancelPsd(){
                this.showPsd=false;
                this.form_psd.old_password = '';
                this.form_psd.new_password = '';
                this.form_psd.r_password = '';
            }
        },
        /*watch: {
            head_img(new_img){
                bus.$emit('headChange',new_img)
            }
        }*/
    }
</script>
<style>
    .msg-form .el-form-item__label{
        font-family: AlibabaPuHuiTiR;
        font-size: 14px;
        color: #999999;
    }
    .msg-form .el-form-item__content{
        width: 260px;
    }
</style>
<style scoped>
    .page-info{
        font-size: 14px;
    }
    .msg-item{
        padding: 15px 0;
    }
    .msg-item>span{
        width: 140px;
        text-align: right;
        padding: 0 12px 0 0;
        box-sizing: border-box;
        font-family: AlibabaPuHuiTiR;
        font-size: 14px;
        color: #999999;
    }
    .msg-item .el-button.change-btn,.get_code{
        margin-left: 30px;
        color: #ff6d33;
        font-size: 14px;
    }
    .msg-item .el-button:hover,.get_code:hover{
        color: #FFA784;
    }
    .el-form--inline .el-form-item{
        display: block;
    }
    .demo-form-inline{
        border-top: solid 1px #f0f0f0;
        padding-top: 16px;
        margin-top: 16px;
    }
    .demo-name-inline{
        border-bottom: solid 1px #f0f0f0;
        padding-top: 16px;
    }
    .msg-form-btn .el-button{
        width: 68px;
        height: 38px;
        padding: 0;
        line-height: 38px;
        text-align: center;
        font-size: 14px;
    }
    .msg-form-btn .btn-bd-p{
        background-color: #fff;
        border-color:#ff6d33;
        color: #ff6d33;
    }
    .msg-form-btn .btn-bd-p:hover{
        background-color: #DCFFEF;
    }
    .code_input{
        width: 65%;
        vertical-align: middle;
    }
    .get_code{
        width: calc(35% - 10px);
        height: 38px;
        overflow: hidden;
        vertical-align: middle;
        margin-left: 10px;
        border-radius: 4px;
    }

    .info-upload{display: inline;}
</style>

